"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ChatInfo = function ChatInfo(_ref) {
  var name = _ref.name,
      time = _ref.time,
      props = _objectWithoutProperties(_ref, ["name", "time"]);

  return _react.default.createElement("div", _extends({
    className: "co-chat__info"
  }, (0, _getNativeProps.default)(props)), _react.default.createElement("span", null, "".concat(name ? name + ' • ' : '').concat(time)));
};

ChatInfo.displayName = 'Chat.Info';
ChatInfo.propTypes = {
  name: _propTypes.string,
  time: _propTypes.string.isRequired
};
var _default = ChatInfo;
exports.default = _default;
ChatInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Chat.Info",
  "props": {
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "time": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  }
};